export default "__VITE_ASSET__CYFhYZWz__$_?component__"